import { NgModule } from '@angular/core';
import { CustomersListComponent } from 'app/components/customers-list/customers-list.component';
import { SharedModule } from 'app/shared/shared.module';
import { OrganizationSummaryPreviewComponent } from './organization-summary-preview.component';

@NgModule({
  declarations: [
    OrganizationSummaryPreviewComponent
  ],
  imports: [
    SharedModule
  ],
  exports:[
    OrganizationSummaryPreviewComponent
  ]
})
export class OrganizationSummaryPreviewModule { }
